import styled, { css } from 'styled-components';

import { Flex, Grid, IconAwardRibbon, mediaMixin, spaceMixin, Spacer, token } from '@zillow/constellation';

const breakpoints = ['sm', 'md', 'lg', 'xl', 'xxl'];
const footerHeight = '94px';

const displayCSS = (mediaProps: { display: string }) => css`
  display: ${mediaProps.display};
`;

const getMobileView = (props: { showDesktopViewBreakpoint: string }) => {
  const { showDesktopViewBreakpoint } = props;

  return css`
    ${mediaMixin(
      showDesktopViewBreakpoint,
      css`
        display: none;
      `,
    )};
  `;
};

const getDesktopView = (props: { showDesktopViewBreakpoint: string }) => {
  const { showDesktopViewBreakpoint } = props;

  const mediaQueryIndex = breakpoints.findIndex((breakpoint) => breakpoint === showDesktopViewBreakpoint);

  const mobileMediaQueryIndex = mediaQueryIndex - 1;
  const mobileMediaQuery = breakpoints[mobileMediaQueryIndex].concat('_lte');

  return css`
    ${mediaMixin(
      mobileMediaQuery,
      css`
        display: none;
      `,
    )};
  `;
};

export const StyledWizardTipCardContainerMobile = styled.div`
  ${getMobileView}
`;

export const StyledWizardTipCardContainerDesktop = styled.div`
  ${getDesktopView}
`;

export const StyledWizardContainer = styled(Flex)`
  background-color: ${token('colors.white')};
  width: 100%;

  .transition-wrapper {
    height: 100%;
  }

  ${mediaMixin(
    'md',
    css`
      height: 100vh;
    `,
  )}
`;

export const StyledContentContainer = styled(Spacer)`
  ${(props: { backgroundColor: string }) => css`
    background-color: ${token(`colors.${props.backgroundColor}`)};
  `}
  height: 100%;
  border-top: 1px solid ${token('colors.gray300')};
  overflow-x: hidden;

  /* fix content not visible on mobile view  */
  ${(props: { hideFooter?: boolean }) =>
    !props.hideFooter &&
    css`
      margin-bottom: ${footerHeight};
    `}
  border-bottom: none;

  overflow-y: auto;

  /* 0 */
  ${mediaMixin(
    'xs',
    css`
      padding: 0 16px;
    `,
  )}

  /* 769 */
    ${mediaMixin(
    'lg',
    css`
      padding: 0 24px;

      /* fix for content not visible is no longer needed */
      border-bottom: 1px solid ${token('colors.gray300')};
      margin-bottom: 0;
    `,
  )}

    /* 1281 */
    ${mediaMixin(
    'xxl',
    css`
      padding: 0 104px;
    `,
  )}

    .content-grid {
    /* keeps content aligned with the grid's second column at 1440 */
    max-width: 1232px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledWizardTitle = styled.div`
  ${(props: { hideDesktopWizardLabel?: boolean }) =>
    props.hideDesktopWizardLabel &&
    css`
      visibility: hidden;
    `}
`;

export const StyledExitCTA = styled.div`
  ${(props: { hideExitCTA?: boolean }) =>
    props.hideExitCTA &&
    css`
      visibility: hidden;
    `}
`;

export const StyledWizardTipCardContainer = styled.div`
  ${(props: { showDesktopViewBreakpoint: string }) =>
    // adds margin for desktop view between the WizardTipCard
    css`
      ${mediaMixin(
        props.showDesktopViewBreakpoint,
        css`
          // the width of a grid column
          margin-left: 105px;
        `,
      )};
    `}
`;

export const StyledMobileGrid = styled(Grid)`
  border-top: 1px solid ${token('colors.gray300')};
  ${(props: { hideProgressStepperAtLTEDesktopViewBreakpoint?: boolean }) =>
    props.hideProgressStepperAtLTEDesktopViewBreakpoint &&
    css`
      display: none;
    `}

  ${getMobileView}
`;

export const StyledDesktopSpacer = styled(Spacer)`
  ${getDesktopView}
`;

export const StyledSpan = styled.span`
  background-color: ${token('colors.coolGray200')};
  border-radius: 4px;
  padding: ${spaceMixin(0.25)} ${spaceMixin('xs')};
  ${mediaMixin(
    'sm_lte',
    css`
      position: absolute;
    `,
  )};
`;

export const StyledIconAwardRibbon = styled(IconAwardRibbon)`
  vertical-align: middle;
`;
